import { Component, Inject, OnInit, NgModule } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GetRequestActvityAttachmentGQL } from '../../../../generated/cloudapigql';
import { SharedService } from '../../../../services/shared.service';

// export interface DialogData {
//     title: [];
//     type: number;
//     amount: number;
//     att: any [];
// }

@Component({
    selector: 'attachment-dialog',
    templateUrl: 'attachment-dialog.html',
    styleUrls: ['attachment-dialog.scss']
})

export class AttachmentDialog implements OnInit {
    result: any;

    constructor(
        public dialogRef: MatDialogRef<AttachmentDialog>,
        public shareService:SharedService,
        public getRequestActvityAttachmentGQL:GetRequestActvityAttachmentGQL,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {
        if (this._data != null) {
            this.getRequestActvityAttachmentGQL.fetch({
              input:{
                refId:this._data.refId,
                refTable:this._data.refTable,
                module:this._data.module,
              }
            }).subscribe(x=>{
              this.result = x.data.AttachmentByRefIdAndRefTable;
            })
        }
    }

    download(attachment){
      window.open(attachment.resourceUrl)
    }

    ngOnInit() {
    }

    downloadQuotation(url: string) {
        window.open(url);
    }

}
